import { FormattedNumber } from 'i18n'
import { currencyFromSymbol } from 'shared/currency-utilities'
import { ListItem } from '../ListItem'

const HourlyMonthlyRate = ({
    rate,
    disabled,
    isActive = false,
    selectRate,
    discountedRateId,
    promoCodeDiscount,
    selectedRateId,
    waitingList,
}) => {
    const { rateName, $rateId, shortDescription, currencySymbol, id, amount, rateId } = rate

    // differentiate ticket type base on $rateId (property only in hourly tickets) and id (only monthly tickets)
    const currentRate = $rateId || rate
    const currency = currencyFromSymbol(currencySymbol)

    React.useEffect(() => {
        if (calculateIsActive()) {
            selectRate(currentRate)
        }
    }, [])

    const calculatePrice = () => {
        const currentId = rateId || id
        return discountedRateId == currentId ? amount - promoCodeDiscount : amount
    }
    const calculateIsActive = () => {
        const currentId = $rateId || id
        return selectedRateId == currentId ? true : isActive
    }

    const onClickHandler = () => {
        if (disabled) return
        selectRate(currentRate)
    }

    return (
        <ListItem
            oldPrice={
                amount !== calculatePrice() ? (
                    <FormattedNumber value={amount} style="currency" currency={currency} />
                ) : (
                    ''
                )
            }
            onClick={onClickHandler}
            title={rateName}
            description={shortDescription}
            price={<FormattedNumber value={calculatePrice()} style="currency" currency={currency} />}
            isActive={calculateIsActive()}
            disabled={disabled}
            errorMessage={
                !waitingList && currentRate.isOnWaitingList ? <T>booking.waitingList.rateDescription</T> : null
            }
        />
    )
}

export default HourlyMonthlyRate
